export default __webpack_public_path__ + "static/media/hospitality.d210458e.png";